import * as React from "react";
import { css } from "@emotion/react";
import { HotelShowParam } from "main/javascripts/types/hotelShowParam";
import { Icon } from "main/javascripts/components/atoms/Icon";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  fontSize,
  fontWeight,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import {
  accentColor,
  borderColor,
} from "main/javascripts/styles/base/colorStyle";
import {
  hotelShowParamTotalNumberOfAdult,
  hotelShowParamTotalNumberOfChildren,
} from "main/javascripts/slices/paramSlice";

export interface IProps {
  param: HotelShowParam;
  displayForm(): void;
}

export const HotelRoomParam: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { param, displayForm } = props;

  const onClick: () => void = () => {
    displayForm();
  };

  return (
    <div css={blockStyle}>
      <div css={dateBlockStyle}>
        <div css={dateItemStyle}>
          <div css={dateLabelStyle}>チェックイン</div>
          <div css={dateStyle}>{param.checkinDate}</div>
        </div>
        <div css={dateItemStyle}>
          <div css={dateLabelStyle}>チェックアウト</div>
          <div css={dateStyle}>{param.checkoutDate}</div>
        </div>
      </div>
      <div css={numBlockStyle}>
        {param.guests.length}室 / 大人 {hotelShowParamTotalNumberOfAdult(param)}
        人 / 子供 {hotelShowParamTotalNumberOfChildren(param)}人
      </div>
      <a css={linkSwitchStyle} onClick={onClick}>
        <span css={linkIconStyle}>
          <Icon styleKey="arrowRight" />
        </span>
        条件を変更する
      </a>
    </div>
  );
};

const blockStyle = css`
  padding: ${space.atom};
  margin: 0 auto;
  box-sizing: border-box;
  max-width: 400px;
  text-align: center;
`;
const dateBlockStyle = css`
  display: flex;
  align-items: center;
  font-size: ${fontSize.caption};
  line-height: ${lineHeight.caption2};
  padding-top: ${space.atom};
`;
const dateItemStyle = css`
  width: 50%;
  border-right: 1px solid ${borderColor.primaryDarkColor};
  &:last-of-type {
    border-right: 0;
  }
`;
const dateLabelStyle = css`
  font-weight: ${fontWeight.bold};
  text-align: center;
`;
const dateStyle = css`
  box-sizing: border-box;
  text-align: center;
`;
const numBlockStyle = css`
  text-align: center;
  font-size: ${fontSize.caption};
  line-height: ${lineHeight.caption1};
  padding-top: ${space.atom};
  padding-bottom: ${space.atom};
`;
const linkSwitchStyle = css`
  font-size: ${fontSize.caption};
  line-height: ${lineHeight.caption2};
  color: ${accentColor.primaryColor};
  cursor: pointer;
`;
const linkIconStyle = css`
  font-size: ${fontSize.smallest};
  padding-right: ${space.atom0_5x};
`;
